import { render, staticRenderFns } from "./DsVideoDetail.vue?vue&type=template&id=d5683e7c&scoped=true"
import script from "./DsVideoDetail.vue?vue&type=script&lang=js"
export * from "./DsVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./DsVideoDetail.vue?vue&type=style&index=0&id=d5683e7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5683e7c",
  null
  
)

export default component.exports